/**
 * OAuth redirect URIs must not contain fragments (RFC 6749 §3.1.2), but the
 * second screen lives in the URL hash (see ScreensService). Before any
 * Keycloak login redirect the hash is stashed in sessionStorage and the
 * redirect URI is sent without it; ScreensService restores the stash on
 * the first navigation after boot.
 */
export const LOGIN_HASH_STASH_KEY = 'hqdp-login-hash-stash';

/**
 * Stash the fragment of `url` (if any) and return the URL without it.
 *
 * Deliberately does NOT clear an existing stash when the URL has no fragment:
 * the OAuth flow boots the app twice (once before the redirect — hash present,
 * stash written — and once on the return from Keycloak — hash gone, OAuth
 * params in the query). Clearing here on the second boot would erase the stash
 * right before ScreensService.restoreLoginStashOnce() consumes it.
 * Staleness is bounded instead by the restore side, which consumes the entry
 * on the first navigation of every boot.
 */
export function stashHashAndStripUrl(url: string): string {
  const hashIndex = url.indexOf('#');
  const withoutFragment = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const fragment = hashIndex === -1 ? '' : url.slice(hashIndex + 1);
  if (fragment) {
    try {
      sessionStorage.setItem(LOGIN_HASH_STASH_KEY, fragment);
    } catch {
      // sessionStorage unavailable — losing the secondary pane across a login is acceptable.
    }
  }

  return withoutFragment;
}
